import { Popover } from 'antd';
import React, { useState } from 'react';
import classNames from 'classnames';

import InformationIcon from '../icons/informationIcon';
import s from './styles.module.scss';
import CrossIcon from '../icons/crossIcon';

import type { PopoverProps } from 'reactstrap';
import type { TooltipPlacement } from 'antd/es/tooltip';
import type { ReactElement, ReactNode, FC } from 'react';

interface BaseTooltipProps {
  content?: ReactNode;
  icon?: ReactElement<{ 'data-open': boolean }>;
  contentClassName?: string;
  contentWrapperClassName?: string;
  placement?: TooltipPlacement;
  trigger?: PopoverProps['trigger'];
  closable?: boolean;
}

const InformationTooltip: FC<BaseTooltipProps> = ({
  content,
  icon,
  contentClassName,
  contentWrapperClassName,
  placement = 'bottomRight',
  trigger = 'click',
  closable = true,
}) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen((prev) => !prev);

  return (
    <Popover
      open={open}
      trigger={trigger}
      placement={placement}
      arrow={false}
      content={() => (
        <div
          className={classNames(s.content, contentWrapperClassName)}
          data-open={open}
        >
          <div className={contentClassName} data-cy="popover-content">
            {content}
          </div>
          {closable && (
            <CrossIcon onClick={toggleOpen} className={s['close-icon']} />
          )}
        </div>
      )}
      onOpenChange={setOpen}
    >
      {icon && React.isValidElement(icon) ? (
        React.cloneElement(icon, { 'data-open': open })
      ) : (
        <InformationIcon className={s.icon} />
      )}
    </Popover>
  );
};
export default InformationTooltip;
